import { render, staticRenderFns } from "./AppLayer.vue?vue&type=template&id=3521c1e7&"
import script from "./AppLayer.vue?vue&type=script&lang=js&"
export * from "./AppLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports